import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './assets/laravel-form.css';

// Suppress MetaMask and other browser extension errors
window.addEventListener('error', (event) => {
  // Filter out MetaMask-related errors
  if (event.error && event.error.message &&
      (event.error.message.includes('MetaMask') ||
       event.message.includes('MetaMask') ||
       event.message.includes('chrome-extension://'))) {
    event.preventDefault();
    console.debug('Suppressed browser extension error:', event.message);
    return false;
  }
});

// Suppress unhandled promise rejections from browser extensions
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message &&
      (event.reason.message.includes('MetaMask') ||
       event.reason.message.includes('chrome-extension://'))) {
    event.preventDefault();
    console.debug('Suppressed browser extension promise rejection:', event.reason.message);
    return false;
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 